/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Spinner } from 'reactstrap';
import { Container } from '~/styles/pagesStyle';

import Menu from '~/components/Menu';
import Lista from './Lista';

import api from '~/services/api';
import Footer from '~/components/Footer';

function ModuloMenuEspec() {
  const history = useHistory();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [moduloNome, setModuloNome] = useState('');
  const [menuID, setMenuID] = useState(0);

  useEffect(() => {
    setLoading(true);
    async function getData() {
      await api.get(`Modulo/${id}`).then((response) => {
        setModuloNome(response.data.nome);
        setLoading(false);
      });
    }
    getData();
  }, [id, history]);

  return (
    <Container>
      <Footer />
      <Menu />
      {loading ? (
        <Spinner style={{ width: '3rem', height: '3rem', margin: '5% auto' }} />
      ) : (
        <Lista
          loading={loading}
          moduloName={moduloNome}
          setLoading={setLoading}
          menuID={menuID}
          setMenuID={setMenuID}
        />
      )}
    </Container>
  );
}

export default ModuloMenuEspec;
